<template>
    <div  class="fix-d" @click="hh" :style="{backgroundColor:isActive}" :ref='to'>
      <slot></slot>
    </div>
</template>

<script>
  export default {
    name: 'NavBar-item',
    props:{to:{type:String,default:''},
      activeColor:{type:String,default:'red'}
    },
    data () {
      return {

      }
    },
    methods:{
      hh(x){
        document.title=x.target.innerText;

        this.$emit('haha');
        if(this.$route.path===this.to){


        }else{
           this.$router.replace(this.to)
        }

      }
    },

    mounted(){
      if(this.$route.path===this.to){
        document.title = this.$refs[this.to].innerText
      }
    },
    computed:{
      isActive(){

      if(this.$route.path===this.to){


          return this.activeColor;
      }

      }
    }

  }
</script>

<style>
@import url("./navbar.css");
</style>



// WEBPACK FOOTER //
// src/components/navbar/NavBar-item.vue